/* Shop by mood: tabs pattern (buttons with aria-selected; Left/Right/Home/End move and select),
   an ink blob that slides to the chosen pill, and a short WAAPI entrance for the new mood
   (photo unmasks, mood word rises, cards stagger in). Only the chosen panel is displayed, so other
   moods' images are not fetched until picked. Without this script every mood is shown in full. */
(() => {
  document.querySelectorAll('[data-cjm]').forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('[data-cjm-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-cjm-panel]'));
    const blob = root.querySelector('.cjm__blob');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    if (!tabs.length) return;
    let current = Math.max(0, tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true'));

    const placeBlob = () => {
      const t = tabs[current];
      blob.style.setProperty('--bx', t.offsetLeft + 'px');
      blob.style.setProperty('--bw', t.offsetWidth + 'px');
    };

    const enter = (panel) => {
      if (!panel.animate) return;
      if (reduce.matches) { panel.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 160 }); return; }
      const ease = 'cubic-bezier(0.23, 1, 0.32, 1)';
      const img = panel.querySelector('.cjm__visual img');
      if (img) img.animate([{ clipPath: 'inset(100% 0 0 0)', transform: 'scale(1.12)' }, { clipPath: 'inset(0 0 0 0)', transform: 'scale(1)' }], { duration: 760, easing: 'cubic-bezier(0.77, 0, 0.175, 1)' });
      panel.querySelectorAll('.cjm__word .w > span').forEach((w, i) => w.animate([{ transform: 'translateY(105%)' }, { transform: 'none' }], { duration: 700, delay: 220 + i * 70, easing: ease, fill: 'backwards' }));
      const info = panel.querySelector('.cjm__info');
      if (info) info.animate([{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 520, delay: 120, easing: ease, fill: 'backwards' });
      panel.querySelectorAll('.cjm__item, .cjm__ways li').forEach((li, i) => li.animate([{ opacity: 0, transform: 'translateY(22px) scale(0.98)' }, { opacity: 1, transform: 'none' }], { duration: 560, delay: 180 + Math.min(i, 6) * 55, easing: ease, fill: 'backwards' }));
    };

    function select(i, focus) {
      if (i === current) return;
      tabs[current].setAttribute('aria-selected', 'false');
      tabs[current].tabIndex = -1;
      panels[current].classList.remove('is-on');
      current = i;
      const t = tabs[i];
      t.setAttribute('aria-selected', 'true');
      t.tabIndex = 0;
      if (focus) t.focus();
      t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce.matches ? 'auto' : 'smooth' });
      root.dataset.atmo = t.dataset.atmo;
      panels[i].classList.add('is-on');
      placeBlob();
      enter(panels[i]);
      updateArrows(panels[i]);
    }

    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i, false));
      t.addEventListener('keydown', (e) => {
        const n = tabs.length;
        const to = { ArrowRight: (current + 1) % n, ArrowLeft: (current - 1 + n) % n, Home: 0, End: n - 1 }[e.key];
        if (to === undefined) return;
        e.preventDefault();
        select(to, true);
      });
    });

    // Rail arrows (desktop): shown only when the rail actually overflows.
    function updateArrows(panel) {
      const rail = panel.querySelector('[data-cjm-rail]');
      const nav = panel.querySelector('[data-cjm-nav]');
      if (!rail || !nav) return;
      const max = rail.scrollWidth - rail.clientWidth;
      nav.hidden = max < 8;
      const [prev, next] = nav.querySelectorAll('[data-cjm-step]');
      prev.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft > max - 4;
    }
    panels.forEach((panel) => {
      const rail = panel.querySelector('[data-cjm-rail]');
      if (!rail) return;
      rail.addEventListener('scroll', () => updateArrows(panel), { passive: true });
      panel.querySelectorAll('[data-cjm-step]').forEach((b) => b.addEventListener('click', () => {
        rail.scrollBy({ left: +b.dataset.cjmStep * rail.clientWidth * 0.8, behavior: reduce.matches ? 'auto' : 'smooth' });
      }));
    });

    // Ambient facets rest while the section is off screen.
    new IntersectionObserver((e) => root.classList.toggle('is-off', !e[0].isIntersecting)).observe(root);
    addEventListener('resize', () => { placeBlob(); updateArrows(panels[current]); }, { passive: true });

    root.classList.add('is-live');
    placeBlob();
    updateArrows(panels[current]);
  });
})();
